import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import type {
  AlignSelfProps,
  BackgroundColorProps,
  BorderRadiusProps,
  ColorProps,
  WidthProps,
} from 'styled-system';
import {
  alignSelf,
  backgroundColor,
  borderRadius,
  color,
  margin,
  padding,
  width,
} from 'styled-system';

import type { SpaceProps } from '../theme/system-types';
import type {
  BoxSizingProps,
  TextTransformProps,
  WhiteSpaceProps,
} from '../theme/system-utilities';
import { boxSizing, textTransform, whiteSpace } from '../theme/system-utilities';
import type { PropsWithRequiredChildren } from '../types/React';
import { HeadlineH9 } from './Typography';

const BaseLabel = styled.span<
  WhiteSpaceProps &
    AlignSelfProps &
    BorderRadiusProps &
    BackgroundColorProps &
    ColorProps &
    TextTransformProps &
    SpaceProps &
    BoxSizingProps &
    WidthProps
>`
  ${whiteSpace};
  ${margin};
  ${alignSelf};
  ${borderRadius};
  ${padding};
  ${backgroundColor};
  ${color};
  ${textTransform};
  ${boxSizing};
  ${width};
`;

const highlightLabelStyles: ComponentProps<typeof BaseLabel> = {
  whiteSpace: 'nowrap',
  borderRadius: 'medium',
  p: 'sp_4',
  color: 'sys.primary.text.active',
  backgroundColor: 'sys.primary.background.weak',
  alignSelf: 'flex-start',
  ml: 'sp_4',
};

type HighlightLabelProps = PropsWithRequiredChildren<ComponentProps<typeof BaseLabel>> & {
  Typography?: typeof HeadlineH9;
};

export const HighlightLabel = ({
  children,
  Typography = HeadlineH9,
  ...props
}: HighlightLabelProps) => (
  <BaseLabel as={Typography} {...highlightLabelStyles} {...props}>
    {children}
  </BaseLabel>
);
